import { render, staticRenderFns } from "./viewMc.vue?vue&type=template&id=778a09d7&scoped=true&"
import script from "./viewMc.vue?vue&type=script&lang=js&"
export * from "./viewMc.vue?vue&type=script&lang=js&"
import style0 from "./viewMc.vue?vue&type=style&index=0&id=778a09d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a09d7",
  null
  
)

export default component.exports